import { useNotifications, notifySuccess } from 'Logic/Notifications.js'

export default function useListItemDataOnActionOAuth2AuthorizationCodeConnected(
  props,
  data,
  reExecuteQuery
) {
  let [, notify] = useNotifications()
  return async function onSubmit({ value, args, change }) {
    change(next => {
      next.connecting = false
    })
    reExecuteQuery({ requestPolicy: 'network-only' })
    return notify(notifySuccess(`The app is connected`, value.name))
  }
}
